<template>
  <div class="product-package-horizontal-content-container">
    <div class="section">
      <p>Package</p>
      <h1 :class="colorClass">R {{ Math.round(pkg.price) | currency }}</h1>
      <span class="title-icon">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.insuranceEducationInfoIcon}`)
          "
          class="info-icon mr-2"
          contain
        />
      </span>
    </div>
    <p>Cover for estate administration costs</p>
    <div class="section">
      <p>Premium</p>
      <h1 :class="colorClass">
        R {{ Math.round(pkg?.premium || 0) | currency }} pm
      </h1>
    </div>
    <p>Amount you pay per month</p>
  </div>
</template>

<script>
  export default {
    name: 'ProductPackageHorizontalContent',
    props: {
      product: {
        required: true,
        type: String,
      },
      pkg: {
        required: true,
        type: Object,
      },
    },
    computed: {
      colorClass() {
        switch (this.product) {
          case 'Estate':
            return 'estate-assist-color';
          case 'Edu':
            return 'education-assist-color';
          case 'Debt':
            return 'debt-assist-color';
          case 'Cash':
            return 'cash-assist-color';
          case 'Cost':
            return 'cost-assist-color';
          case 'Tax':
            return 'tax-assist-color';
          default:
            return '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-package-horizontal-content-container {
    width: 100%;

    p {
      color: #282828;
      margin: 0;
      margin-top: 1px;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
    }

    .section {
      margin-top: 10px;
      display: flex;
      align-items: center;

      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        text-wrap: nowrap;
        color: #282828;
        margin: 0;
      }
      h1 {
        margin-left: 4px !important;
        font-size: 20px;
        font-weight: 600;
        line-height: 30px;
        text-wrap: nowrap;
        margin-right: 4px !important;
        margin: 0;
      }

      .title-icon {
        margin-top: -12px;
      }

      h1.estate-assist-color {
        color: #ed0080;
      }

      h1.education-assist-color {
        color: #7395ef;
      }

      h1.debt-assist-color {
        color: #d65e23;
      }

      h1.cash-assist-color {
        color: #8aba3e;
      }

      h1.cost-assist-color {
        color: #e9ab21;
      }

      h1.tax-assist-color {
        color: #e9ab21;
      }
    }
    .section:first-child {
      margin-top: 0;
    }
  }
</style>
